import React from "react";
import {Kinetic} from "./Kinetic";

export const Tools = () => {
  return <div>
              <Kinetic />
  </div>
}